export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_UNSUCCESS = 'LOGIN_UNSUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const SET_ISLOGGEDIN_TRUE = 'SET_ISLOGGEDIN_TRUE';
export const GET_ALL_TRANSACTION = 'GET_ALL_TRANSACTION';
